import * as React from 'react';
import { ReportView } from 'app/area/company-report/report-view';

interface ReportRouteProps {
  params: {
    companyReportId: string;
    favouriteId: string;
  };
  router: { location: { query: { editSavedFavourite?: string }}};
}

export function ReportRoute({
  params,
  router
}: ReportRouteProps) {
  const companyReportId = parseInt(params.companyReportId, 10);
  const favouriteId = params?.favouriteId && parseInt(params.favouriteId, 10);
  const editSavedFavourite = Boolean(router.location?.query?.editSavedFavourite);

  return (
    <ReportView
      companyReportId={companyReportId}
      editSavedFavourite={editSavedFavourite}
      favouriteId={favouriteId}
    />
  );
}
